import { PeopleAndGroupConnectionsQueryDocument } from "@pathwright/graphql-client/src/generated"

export default PeopleAndGroupConnectionsQueryDocument
